












































































import Component from 'vue-class-component';
import Vue from 'vue';
import {isEmpty, logger} from "../../plagins/utils";
import {Kt, Record} from '../interfaces';
import {State} from "../store";
import {trans} from "../../plagins/translate";
import Template1 from "../templates/Template1.vue";
import Template2 from "../templates/Template2.vue";

declare global {
    interface Window {
        json_context: any;
    }
}


@Component({
    components: {Template1, Template2}
})
export default class Home extends Vue {

    state: State | any = {};


    trans(s: string): string {
        return trans(s);
    }


    getKtTitle(kt: Kt) {
        return this.state.settings.columns[kt.id].title;
    }


    mounted(): void {

    }

    // isEmpty(value: any): boolean {
    //     return isEmpty(value);
    // }


    created(): void {
        this.state = this.$store.state;
    }

    destroyed(): void {

    }
}
